import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fb1efaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "d-flex align-center justify-space-between my-4" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Selecionar usuário Admin", -1))
const _hoisted_6 = { class: "area-responsibles" }
const _hoisted_7 = ["onClick"]

import { ref, watch, withDefaults, computed } from 'vue';

import { MoleculeModal } from '@/components/molecules';
import { Company, User } from '@/core/model';
import { create, update } from '@/core/service/CompanyService';
import { Preloader, Authentication } from '@/store';
import Swal from 'sweetalert2';
import { AtomInput, AtomCheckBox, AtomButton, AddUserIcon, SearchIcon } from '@/components/atoms';
import UserModal from './MoleculeUserModal.vue';
interface IProps {
    showModal?: boolean
    model?: Company,
    users: User[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCompanyModal',
  props: {
    showModal: { type: Boolean, default: false },
    model: null,
    users: null
  },
  emits: ['onHandleClose', "onLoadUser"],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, model?: Company, users: User[] };



const searchUsers = computed(() => {
    return search.value ? props.users.filter(f => f.name?.toUpperCase().includes(search.value.toUpperCase())) : props.users;
})
const search = ref<string>("");
const isAdd = ref<boolean>(false);
const data = ref<Company>({});
function setResponsable(item: User) {
    data.value.responsible_id = item.id;
}
function handleAddUser(event: boolean) {

    if (event) emit("onLoadUser", true);
    isAdd.value = false;
}

function handleAddOrUpdate() {
    Preloader.actions.ActionSetPreloader(true);
    if (data.value.cnpj)
        data.value.cnpj = data.value.cnpj?.split('.').join("").split("-").join('').split("/").join("");
    if (!data.value.id) {
        data.value.id = undefined;
        if (!data.value.id) {
            data.value.id = undefined;
            create(data.value)
                .then((res) => {
                    // Swall
                    Swal.fire({
                        title: 'Sucesso !',
                        text: `Empresa ${data.value.fantasy_name} foi criada com sucesso !`,
                        icon: 'success',
                    });
                    emit("onHandleClose", true);
                })
                .finally(() => {
                    Preloader.actions.ActionSetPreloader(false);
                });
        } else {
            update(data.value)
                .then((r) => {
                    // swall
                    Swal.fire({
                        title: 'Sucesso !',
                        text: `Empresa ${data.value.fantasy_name} foi atualizada com sucesso !`,
                        icon: 'success',
                    });

                    emit("onHandleClose", true);
                })
                .finally(() => {
                    Preloader.actions.ActionSetPreloader(false);
                });
        }
    }
}
function clear() {
    data.value = {};

    emit("onHandleClose", false);
}

watch(() => props.model,
    () => {
        if (props.model)
            data.value = props.model;
    })




return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MoleculeModal), {
      width: "649px",
      onHandleConfirm: handleAddOrUpdate,
      onHandleCancel: clear,
      icon: "CompanyIcon",
      iconColor: "#5528B5",
      title: "Cadastro de empresa",
      subtitle: 'Preencha todos os campos corretamente para cadastrar uma nova empresa',
      show: props.showModal,
      "btn-close-text": "Cancelar",
      "btn-confirm-text": "Salvar",
      btnConfitmDisabled: false
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(AtomInput), {
              maxWidth: '100%',
              msgError: "Campo obrigatório",
              placeholder: "Razão Social*",
              modelValue: data.value.corporate_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.corporate_name) = $event)),
              classes: "mb-5"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(AtomInput), {
              maxWidth: '100%',
              "has-error": false,
              msgError: "Campo obrigatório",
              placeholder: "Nome Fantasia*",
              modelValue: data.value.fantasy_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.fantasy_name) = $event)),
              classes: "mb-5"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(AtomInput), {
              mask: "##.###.###/####-##",
              maxWidth: '100%',
              msgError: "Campo obrigatório",
              placeholder: "Cnpj*",
              modelValue: data.value.cnpj,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.cnpj) = $event)),
              classes: "mb-5"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(AtomInput), {
              maxWidth: '100%',
              msgError: "Campo obrigatório",
              placeholder: "Email*",
              modelValue: data.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.email) = $event)),
              classes: "mb-5"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(AtomInput), {
              maxWidth: '100%',
              msgError: "Campo obrigatório",
              placeholder: "Telefone*",
              modelValue: data.value.phone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.phone) = $event)),
              mask: "(##) #####-####",
              classes: "mb-5"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(AddUserIcon)),
                _hoisted_5
              ]),
              (_unref(Authentication).actions.hasPermission('/users', 'CREATE'))
                ? (_openBlock(), _createBlock(_unref(AtomButton), {
                    key: 0,
                    background: "white",
                    outlined: "",
                    class: "pa-2 px-4 ms-4",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (isAdd.value = true), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Novo usuário ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(AtomInput), {
              "append-icon": "",
              prependIcon: "",
              noBgPrependIcon: "",
              noBorderPrependIcon: "",
              placeholder: "Pesquisar",
              modelValue: search.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((search).value = $event)),
              width: "100%",
              classes: "w-100 my-3"
            }, _createSlots({
              prependIcon: _withCtx(() => [
                _createVNode(_unref(SearchIcon))
              ]),
              _: 2
            }, [
              (search.value)
                ? {
                    name: "appendIcon",
                    fn: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => { search.value = ''}, ["prevent","stop"]))
                      }, "X")
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue"]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchUsers), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["d-flex align-center justify-space-between py-6 px-4 border rounded item-user mb-5", { active: data.value.responsible_id == item.id }]),
                  onClick: ($event: any) => (setResponsable(item))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.name), 1),
                  _createVNode(_unref(AtomCheckBox), {
                    onClick: ($event: any) => (setResponsable(item)),
                    checked: data.value.responsible_id == item.id
                  }, null, 8, ["onClick", "checked"])
                ], 10, _hoisted_7))
              }), 128))
            ]),
            _createVNode(_component_v_divider)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(UserModal, {
      "show-modal": isAdd.value,
      onOnHandleClose: handleAddUser
    }, null, 8, ["show-modal"])
  ], 64))
}
}

})